import { useEffect, useRef, useState } from 'react';
import { Sparkles } from 'lucide-react';

// Keep the clock in the parent so closing the dialog does not restart it.
// A pause in visible text is not completion: the final response is still pending.
export function useCreationActivity(busy, reply) {
  const lastTextAt = useRef(0);
  const [clock, setClock] = useState({ elapsed: 0, quiet: false });
  useEffect(() => { lastTextAt.current = Date.now(); }, [reply]);
  useEffect(() => {
    if (!busy) { setClock({ elapsed: 0, quiet: false }); return; }
    const startedAt = Date.now();
    lastTextAt.current = startedAt;
    const tick = () => {
      const now = Date.now();
      setClock({ elapsed: Math.floor((now - startedAt) / 1000), quiet: now - lastTextAt.current >= 2000 });
    };
    tick();
    const timer = window.setInterval(tick, 1000);
    return () => window.clearInterval(timer);
  }, [busy]);
  const phase = !reply ? 'thinking' : clock.quiet ? 'organizing' : 'replying';
  const title = phase === 'thinking' ? '正在思考中' : phase === 'replying' ? '正在回复中' : '还在整理中';
  const detail = clock.elapsed >= 15 ? '这次需要多一点时间，完成后会自动显示。'
    : phase === 'thinking' ? '正在理解你的想法，请稍候。' : '回复尚未结束，请稍候。';
  return { ...clock, phase, title, detail };
}

export default function CreationActivity({ activity }) {
  return <div className="creation-activity" data-phase={activity.phase}>
    <span className="creation-activity__symbol" aria-hidden="true"><Sparkles size={18} /></span>
    <div className="creation-activity__copy" role="status" aria-live="polite" aria-atomic="true">
      <strong>{activity.title}<span className="home-intake__dots" aria-hidden="true"><i /><i /><i /></span></strong>
      <p>{activity.detail}</p>
    </div>
    <span className="creation-activity__elapsed" aria-label={`已用时 ${activity.elapsed} 秒`}><span>已用时</span><b>{activity.elapsed}<small>秒</small></b></span>
    <span className="creation-activity__track" aria-hidden="true"><i /></span>
  </div>;
}
